import { render } from "./FilterAnnotationsWithPreview.vue?vue&type=template&id=50fddb0a"
import script from "./FilterAnnotationsWithPreview.vue?vue&type=script&lang=js"
export * from "./FilterAnnotationsWithPreview.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__